// Enum for the tab group for violations
export enum VIOLATION_TABS {
  DUPLICATE_ID = 'Duplicate Id Records',
  DUPLICATE_ENG_DTL = 'Eng Rules Violation',
  DUPLICATE_TRAN_DTL = 'Trans Rules Violation',
  DUPLICATE_BAT = 'Battery Rules Violation',
  DUPLICATE_ELEC = 'Electr Rules Violation',
  DUPLICATE_PRI_DRV = 'PrimDr Rules Violation',
  DUPLICATE_SEC_DRV = 'SecDr Rules Violation',
  INVALID_PORTTYPE = 'Invalid Port Type Records',
  DATE_VIOLATION = 'Date Violations',
  ITERATION_VIOLATION = 'Iteration Violations',
  VFUEL_VIOLATION = 'VFuel Violations'
}
